import { render, staticRenderFns } from "./ViewCustomerAddresses.vue?vue&type=template&id=12026a9c&scoped=true&"
import script from "./ViewCustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerAddresses.vue?vue&type=style&index=0&id=12026a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12026a9c",
  null
  
)

export default component.exports